/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext } from 'store/context';
import { Layout } from 'components';
import { Content, Heading, Main, HeaderButton, ButtonContainer, AccessButtonHelperText } from './styles';
import { Col, Row } from 'components/Grid';
import ResponsiveEmbed from 'react-responsive-embed';
import { FitinsurAPI, MessageCenter } from 'utils';
import { LoaderContext } from '@fitinsur/contexts';

export default function HomePage() {
  const authContext = useContext(GlobalAuthContext);
  const { updateIsLoadingStatus } = useContext(LoaderContext); 
  const [loading, setLoading] = useState(false);
  const [dashboardQlikUrl, setDashboardQlikUrl] = useState('');

  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  useEffect(() => {
    updateIsLoadingStatus(loading)
  }, [loading]);

  const getPersonRootName = function (authContext) {
    if (authContext.login_response &&
      authContext.login_response.ret_value &&
      authContext.login_response.ret_value.rootFirstName &&
      authContext.login_response.ret_value.rootLastName) {
      return (authContext.login_response.ret_value.rootLastName);
    } else {
      return ("**PERSON NAME NOT FOUND**");
    }
  }

  /*
   20201025 - carlos.oliveira
   teste dashboard embeded via microsoft powerbi
   TO-DOs:
   - configurar constante / acesso perfil broker / cliente (domain + função requestAccess)
   - acionar chamada perfil / accesso para determinar perfil broker / cliente
   - ajustar exibição nome pessoa root
   - obter URL endpoint do dashboard embeded via consulta ao backend (params / perfil)
  
   20210117 - carlos.oliveira
   deploy inicial dashboard via powerbi embed - indicador exposure
  */
  const embedDashboardPowerBi = function (authContext) {
    const idPersonSompo = Number(process.env.REACT_APP_FITINSUR_ID_PERSON_SOMPO);
    const dashBaseUrl = String(process.env.REACT_APP_FITINSUR_INTEGRATION_DASHBOARD);
    const dashConfig = String(process.env.REACT_APP_FITINSUR_INTEGRATION_DASHBOARD_CONFIG);
    let dashContentUrl;

    if (authContext.login_response &&
      authContext.login_response.ret_value &&
      authContext.login_response.ret_value.idPersonRoot) {

      let idPersonRoot = authContext.login_response.ret_value.idPersonRoot;
      if (!Boolean(process.env.REACT_APP_FITINSUR_ID_PERSON_PROD)) idPersonRoot = getTempIdPersonRoot(idPersonRoot);
      if (Number(authContext.login_response.ret_value.idPersonRoot) === Number(idPersonSompo)) {
        dashContentUrl = dashBaseUrl + "/?id_person_root=" + idPersonRoot + "&role_name=broker";
      } else {
        dashContentUrl = dashBaseUrl + "/?id_person_root=" + idPersonRoot + "&role_name=client";
      }
      dashContentUrl += "&config_name=" + dashConfig;
    } else {
      dashContentUrl = "about:blank";
    }

    return (
      <Main>
        <Row>
          <Col sm={12} md={12} lg={12} xl={12}>
            <ResponsiveEmbed
              src={dashContentUrl}
              allowfullscreen
              ratio="16:9"
            />
          </Col>
        </Row>
      </Main>
    );
  }

  //------------------------------------------------------------------------------
  //20210119 - temporario - de-para idpersonroot
  /*
  STAGING
  ID_PERSON	PERSON_FIRST_NAME
  5	AIG-Joao
  101703	TEXEL
  126698	23 Capital
  128679	23 Capital
  129791	Aegis
  129792	AIG
  129793	Arch
  129794	Argenta
  129795	Pembroke
  129796	QBE
  139051	BCGE
  139053	CACIB
  139061	Deutsche
  
  DEVELOPER
  ID_PERSON	PERSON_FIRST_NAME
  5	AIG-Joao
  101703	TEXEL
  126698	23 Capital
  128679	23 Capital
  129791	Aegis
  129792	AIG
  129793	Arch
  129794	Argenta
  129795	Pembroke
  129796	QBE
  130104	BCGE
  130106	CACIB
  130114	Deutsche
  
  INTEGRATION
  ID_PERSON	PERSON_FIRST_NAME
  41	23 Capital
  46	ABN Amro
  48	BCGE
  50	CACIB
  58	Commerzbank
  78	Deutsche
  */

  const getTempIdPersonRoot = function (idPersonRoot) {
    let result;
    const idPersonRootListStg = [
      [41, 126698],
      [46, null],
      [48, 139051],
      [50, 139053],
      [58, null],
      [78, 139061]
    ];
    const idPersonRootListDev = [
      [41, 126698],
      [46, null],
      [48, 130104],
      [50, 130106],
      [58, null],
      [78, 130114]
    ];
    // find on staging list
    idPersonRootListStg.find((element) => {
      if (element[1] == idPersonRoot) result = element[0];
    });
    // find on developer list
    if (!result) {
      idPersonRootListDev.find((element) => {
        if (element[1] == idPersonRoot) result = element[0];
      });
    }
    if (!result) result = idPersonRoot;
    return result;
  }


  const embedDashboardQlik = function () {
    return (
      <Main>
        <ResponsiveEmbed
          src={dashboardQlikUrl}
          allowfullscreen
        />
      </Main>
    );
  }


  if (!authContext.status) {
    history.push('login');
  }

  const handleQlik = () => {
    setLoading(true);
    fitinsur.setAuthToken(authContext.token);
    fitinsur.qlikToken()
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          setLoading(false);
          return;
        } else {
          if (data.embed_url) setDashboardQlikUrl(data.embed_url)
            setLoading(false);
        }
      })
      .catch((error) => {
        mc.error(`Ocorreu um erro ao buscar os dados: ${handleQlik.name}\n` + error);
        setLoading(false);
      })
  }

  const handleAccessHub = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.qlikToken()
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error('Ocorreu um problema ao processar a solicitação');
          return;
        } else {
          window.open(data.url)
        }
      })
      .catch((error) => {
        mc.error(`Ocorreu um erro ao buscar os dados: ${handleAccessHub.name}\n` + error);
      })
  }

  useEffect(() => {
    handleQlik();
  }, [])

  return (
    <>
      <Layout title={'Dashboard'}>
        <Content>
          <Heading>
            Dashboard - {getPersonRootName(authContext)}
          </Heading>
          {process.env.REACT_APP_USE_POWER_BI_DASHBOARD === 'true'
            ? embedDashboardPowerBi(authContext)
            : embedDashboardQlik()
          }
        </Content>
      </Layout>
    </>
  );
}